module.exports = __webpack_public_path__ + "static/media/sf_1300_gray.81f34f38cd2fbe2a57e7f582f759e398.png";